import React, { memo } from "react";
import * as PropTypes from "prop-types";
import { formatValue, getMarker } from "../../../utilities";
import { orderByValues } from "../../../data/data";
import { withStyles } from "@material-ui/core";
import styleConstants from "../../../styleConstants";
import CostVsUsersLegend from "./CostVsUsersLegend";
import MirroredBarChart from "../../chart/MirroredBarChart";

const styles = {
  chart: {
    flex: 1
  },
  container: {
    display: "flex",
    alignItems: "center"
  },
  legend: {
    marginLeft: "2rem"
  }
};

const ShareOfConsumptionCostsVsUsersBySectorChart = props => {
  const data = props.data;

  const areas = [
    "Low-Income (LIC)",
    "Lower-Middle-Income (L-MIC)",
    "Upper-Middle-Income (U-MIC)"
  ];

  const costData = data.filter(datum => datum.indicator === "Cost");
  const userData = data.filter(datum => datum.indicator === "User");

  const series = [
    {
      name: "Public",
      color: styleConstants.categoryColors.sectorColors["Public"],
      data: orderByValues(
        costData.filter(datum => datum.sector === "Public"),
        areas,
        "area"
      ).map(datum => -datum.value),
      stack: "Costs"
    },
    {
      name: "Private",
      color: styleConstants.categoryColors.sectorColors["Private"],
      data: orderByValues(
        costData.filter(datum => datum.sector === "Private"),
        areas,
        "area"
      ).map(datum => datum.value),
      stack: "Costs"
    },
    {
      name: "Public",
      overlay: true,
      data: orderByValues(
        userData.filter(datum => datum.sector === "Public"),
        areas,
        "area"
      ).map(datum => -datum.value),
      stack: "Users",
      color: "black",
      borderColor: "transparent",
      dataLabels: {
        useHTML: true,
        formatter: function() {
          return getMarker(
            styleConstants.categoryColors.sectorColors["Public"]
          );
        },
        enabled: true,
        align: "left",
        padding: -5.5
      },
      showInLegend: false
    },
    {
      name: "Private",
      overlay: true,
      data: orderByValues(
        userData.filter(datum => datum.sector === "Private"),
        areas,
        "area"
      ).map(datum => datum.value),
      stack: "Users",
      color: "black",
      borderColor: "transparent",
      dataLabels: {
        useHTML: true,
        formatter: function() {
          return getMarker(
            styleConstants.categoryColors.sectorColors["Private"]
          );
        },
        enabled: true,
        align: "right",
        padding: -5.5
      },
      showInLegend: false
    }
  ];

  return (
    <div className={props.classes.container}>
      <div className={props.classes.chart}>
        <MirroredBarChart
          ref={props.innerRef}
          height={150}
          headerOffset={52}
          categories={["LIC", "L-MIC", "U-MIC"]}
          series={series}
          legendPosition="none"
          showDataLabels={false}
          tooltipFormatter={function() {
            return `${this.series.name} Share of ${this.key} ${
              this.series.options.stack
            }: <strong>${formatValue(
              Math.abs(this.percentage / 100),
              true
            )}</strong>`;
          }}
        />
      </div>

      <div className={props.classes.legend}>
        <CostVsUsersLegend />
      </div>
    </div>
  );
};

ShareOfConsumptionCostsVsUsersBySectorChart.propTypes = {
  data: PropTypes.array.isRequired
};

export default memo(
  withStyles(styles)(
    React.forwardRef((props, ref) => (
      <ShareOfConsumptionCostsVsUsersBySectorChart innerRef={ref} {...props} />
    ))
  )
);
